import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function putAuthFederationKeyActivationRequestConfig(kid: string, action: 'activate' | 'deactivate'): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'PUT',
    endpoint: `auth-federation/admin/keys/${kid}/${action}`,
    serverWideRequest: false
  };
}

export function callPutAuthFederationKeyActivationRequest(
  kid: string,
  action: 'activate' | 'deactivate'
): Promise<void> {
  return makeJsonRestApiRequest<null, void>({
    config: putAuthFederationKeyActivationRequestConfig(kid, action),
    request: null
  });
}
